// This file is managed by `scripts/sync-addresses.mjs`. Run `bun sync-addresses`
// after each local deploy to refresh it from ../blockpot-contracts' `addresses.json`,
// or pipe a Railway-style CHAINS_CONFIG JSON via `--chains-config-json` for hosted chains.
const BASE_SEPOLIA_ADDRESSES: { [key: string]: `0x${string}` } = {
    'playerRegistry': '0x3ef70131729D029ff8cc87a9B7e62a835E1504fb',
    'kycRegistry': '0x9386528125E64AAAdD23ba00559b1ed697e576b8',
    'operator': '0x250E3D87939070c2A27f15137a6eba852f1B2EfF',
    'operatorRoles': '0x6ef80aa18dFa401F340B1e03098fFD6027A0C744',
    'referralManager': '0xd17dA7123D29CbD42E2075dc2693A28eAa0f7fEc',
    'potSeeder': '0x09bf51A978d606862D2CE4B8831D6494CA988946',
    'draw': '0xf229546d8dfCdF674baCF6420ffAA54Bb0421ce4',
    'quickGame': '0xdb1E44c95Ff13D443BC6f8C7803F3014Ca32713d',
}

export default BASE_SEPOLIA_ADDRESSES
